import { html } from '@polymer/polymer/polymer-element';
import { KatapultWidget } from './katapult-widget';
import { KatapultDialog } from '../../katapult-elements/katapult-dialog';
import '../../paper-table/paper-table';
import '../../style-modules/paper-table-style';
import '../../katapult-auth/katapult-auth';
('../katapult-elements/katapult-button.js');

class EstimatorWidget extends KatapultWidget {
  // Override widget title template
  static get widgetTitleTemplate() {
    return html`Estimator Widget`;
  }
  // Override properties
  static get properties() {
    return {
      pageData: {
        type: Object,
        value: { title: 'Estimation', description: 'Tell me' }
      },
      questions: {
        type: Array,
        value: [
          'How many hours did similar projects take you in the past? - (say 0 if you havent done something like this before)',
          'How many hours will it take you to familiarize yourself with the work involved?',
          'How many steps are involved in this project?',
          'How many hours will you spend making sure your item works?',
          'How many hours will it take you to create the PR?',
          'How many extra hours of overhead for things like client meetings (do not include bathroom breaks, trips to the bagel bar, etc.) would you like to add (say 0 if none)?',
          'How many hours will it take you to estimate the project?',
          'On a scale of 1 to 5, using a whole number, with five being the most confident, how confident are you in the times you provided thus far?'
        ]
      },
      hoursArray: {
        type: Array,
        value: [0, 0, 0, 0, 0, 0, 0, 0]
      },
      currentIndex: {
        type: Number,
        value: 0
      },
      currentQuestion: {
        type: String,
        value: ''
      },
      currentValue: {
        type: Number,
        value: 0
      },
      suggestedEstimate: {
        type: Number,
        value: 0
      },
      stepIndex: {
        type: Number,
        value: 0
      },
      stepsArray: {
        type: Array,
        value: []
      },
      editSteps: {
        type: Boolean,
        value: false
      },
      estimate: {
        low: 0,
        high: 0,
        exact: 0
      },
      quizMode: {
        type: Boolean,
        value: true
      }
    };
  }
  // Override body template
  static get bodyTemplate() {
    return html`
      <style include="paper-table-style katapult-dialog-style">
        #mainTable {
          padding: 5px;
        }
        .button {
          height: 30px;
          width: 100px;
          float: right;
          color: red;
        }
        .activated {
          color: green;
        }
        span {
          font-size: 20px;
          color: #007299;
        }
        .quizButton {
          width: 170px;
          height: 40px;
          background-color: #007299;
          color: white;
        }
        .textDiv {
          padding: 10px;
        }
      </style>
      <paper-table id="mainTable">
        <div style="border-bottom: 4px solid var(--paper-grey-300); padding:5px;">
          <span>ESTIMATOR FOR PROJECTS</span>
          <katapult-button id="dev_mode" on-click="toggleQuizMode" class="button activated">Quiz Mode</katapult-button>
        </div>
        <template is="dom-if" if="[[quizMode]]">
          <div class="textDiv" on-keypress="keyPressedQuiz">
            <div>[[currentQuestion]]</div>
            <paper-input label="Answer" value="{{currentValue}}"></paper-input>
          </div>
          <paper-table>
            <paper-row>
              <katapult-button class="quizButton" on-click="answerNegated">BACK</katapult-button>
              <katapult-button class="quizButton" on-click="answerConfirmed">ENTER</katapult-button>
            </paper-row>
          </paper-table>
        </template>
        <template is="dom-if" if="[[!quizMode]]">
          <div class="textDiv">
            <div style="float:left; width: 50%;">
              <b>Your exact estimate was [[exact]] hours.</b> <br />
              <b>Our suggested estimate is [[suggestedEstimate]] Hours.</b>
            </div>
            <div style="float:right; width: 50%;">
              <div>
                Considering your confidence level, it may take you as little as [[low]] hours or as many as [[high]] hours to complete.
              </div>
            </div>
          </div>
          <paper-table white outline rounded on-keypress="keyPressedTable">
            <paper-row>
              <paper-cell> Similar projects took:</paper-cell>
              <paper-input label="Hours" value="{{hoursArray.0}}"></paper-input>
            </paper-row>
            <paper-row>
              <paper-cell> Time to familarize:</paper-cell>
              <paper-input label="Hours" value="{{hoursArray.1}}"></paper-input>
            </paper-row>
            <paper-row>
              <paper-cell>
                <paper-toggle-button checked="{{editSteps}}" on-click="updateEstimation">Number of Steps:</paper-toggle-button></paper-cell
              >
              <paper-input label="Steps" value="{{hoursArray.2}}"></paper-input>
            </paper-row>
            <iron-collapse opened="{{editSteps}}">
              <template is="dom-repeat" items="{{stepsArray}}" as="row">
                <paper-row>
                  <paper-cell> Step {{addOne(itemsIndex)}}</paper-cell>
                  <paper-input label="Hours" value="{{row}}"></paper-input>
                </paper-row>
              </template>
            </iron-collapse>
            <paper-row>
              <paper-cell> Testing Functionality:</paper-cell>
              <paper-input label="Hours" value="{{hoursArray.3}}"></paper-input>
            </paper-row>
            <paper-row>
              <paper-cell> Creating the PR:</paper-cell>
              <paper-input label="Hours" value="{{hoursArray.4}}"></paper-input>
            </paper-row>
            <paper-row>
              <paper-cell> Overhead:</paper-cell>
              <paper-input label="Hours" value="{{hoursArray.5}}"></paper-input>
            </paper-row>
            <paper-row>
              <paper-cell> Estimating:</paper-cell>
              <paper-input label="Hours" value="{{hoursArray.6}}"></paper-input>
            </paper-row>
            <paper-row>
              <paper-cell> Confidence:</paper-cell>
              <paper-input label="In The Estimate (1-5)" value="{{hoursArray.7}}"></paper-input>
            </paper-row>
          </paper-table>
          <div style="padding: 5px;">
            <katapult-button on-click="updateEstimation" class="quizButton"> Update Estimate</katapult-button>
            <katapult-button on-click="resetValues" class="quizButton" style="float: right;"> Reset</katapult-button>
          </div>
        </template>
      </paper-table>
    `;
  }

  async ready() {
    super.ready();
    this.startQuiz();
  }

  resetValues() {
    this.currentIndex = 0;
    this.suggestedEstimate = 0;
    this.low = 0;
    this.high = 0;
    this.exact = 0;
    this.hoursArray = ['0', '0', '0', '0', '0', '0', '0', '0'];
    this.stepIndex = 0;
    this.stepsArray = [];
  }

  startQuiz() {
    this.resetValues();
    this.valuesUpdate();
  }

  keyPressedQuiz(e) {
    if (e.key === 'Enter') {
      this.answerConfirmed();
    }
  }

  keyPressedTable(e) {
    if (e.key === 'Enter') {
      this.updateEstimation();
    }
  }

  answerConfirmed() {
    if (Number(this.currentValue) < 0 || this.currentValue == '' || this.currentValue == undefined) {
      this.invalidEntry('string');
      return;
    }
    switch (this.currentIndex) {
      // index 2 is the 'how many steps?' question
      case 2:
        switch (this.stepIndex) {
          // first step
          case 0:
            this.hoursArray[this.currentIndex] = this.currentValue;
            this.stepsArray = [0];
            this.stepsUpdate();
            return;
          default:
            // last step
            if (this.stepIndex == this.hoursArray[2]) {
              this.stepsArray[this.stepIndex] = this.currentValue;
              this.currentIndex += 1;
              this.valuesUpdate();
              return;
            }
            // other step
            else {
              this.stepsArray[this.stepIndex] = this.currentValue;
              this.stepsUpdate();
              return;
            }
        }
      // default is any other question than the 'how many steps' question.
      default:
        this.hoursArray[this.currentIndex] = this.currentValue;
        // if we are at index 7, the last question
        if (this.currentIndex == 7) {
          this.currentValue > 0 && this.currentValue <= 5 ? this.finishQuiz() : this.invalidEntry('confidence');
          return;
        }
        this.currentIndex += 1;
        this.valuesUpdate();
    }
  }

  answerNegated() {
    // stepIndex > 0 and index 2 checks for a step question to move to.
    if (this.currentIndex == 2 && this.stepIndex > 0) {
      switch (this.stepIndex) {
        // case 1 is going to the question of 'how many steps'
        case 1:
          this.stepIndex = 0;
          this.valuesUpdate();
          return;

        default:
          this.stepIndex -= 2;
          this.stepsUpdate();
          return;
      }
      // moving to a regular question
    } else {
      this.currentIndex > 0 ? (this.currentIndex -= 1) : null;
      this.valuesUpdate();
    }
  }

  stepsUpdate() {
    this.stepIndex += 1;
    this.currentQuestion = 'How many hours will step ' + this.stepIndex + ' take?';
    this.currentValue = this.stepsArray[this.stepIndex];
  }

  valuesUpdate() {
    this.currentQuestion = this.questions[this.currentIndex];
    this.hoursArray[this.currentIndex] == 0 ? (this.currentValue = '') : (this.currentValue = this.hoursArray[this.currentIndex]);
  }

  updateEstimation() {
    // exception handle
    this.hoursArray.forEach((value, index) => {
      if (value < 0 || value == '') {
        this.hoursArray[index] = '0';
        this.invalidEntry('string');
        return;
      }
    });
    this.stepsArray.forEach((value, index) => {
      if (value < 0 || value == '') {
        this.stepsArray[index] = '0';
        this.invalidEntry('string');
        return;
      }
    });
    if (this.hoursArray[7] < 1 || this.hoursArray[7] > 5) {
      this.hoursArray[7] = 5;
      this.invalidEntry('confidence');
    }
    // notify polymer so the table shows the numbers
    let switchArray = this.hoursArray;
    this.hoursArray = [];
    this.hoursArray = switchArray;
    this.exact = 0;
    let stepValues = this.stepsArray;
    this.stepsArray = [];
    // for every step we have, update the array accordingly
    for (let i = 0; i < Number(this.hoursArray[2]); i++) {
      stepValues[i] ? (this.stepsArray[i] = stepValues[i]) : (this.stepsArray[i] = 0);
    }
    // add all the hours up, skip the first question, the num of steps, and confidence num.
    this.hoursArray.forEach((value, index) => {
      if (index != 0 && index != 2 && index != 7) this.exact += Number(value);
    });
    // add all of the steps to the total
    this.stepsArray.forEach((value) => {
      this.exact += Number(value);
    });
    this.confidenceEstimate(Number(this.hoursArray[7]), this.exact);
    if (Number(this.hoursArray[0]) == 0) {
      this.suggestedEstimate = Math.round((this.exact * 4 + this.high * 5) / 9);
    } else {
      this.suggestedEstimate = Math.round((Number(this.hoursArray[0]) * 4 + this.exact * 3 + this.high * 5) / 12);
    }
  }

  confidenceEstimate(confidence, estimation) {
    switch (confidence) {
      case 1:
        this.low = Math.round(0.125 * estimation);
        this.high = Math.round(8 * estimation);
        break;
      case 2:
        this.low = Math.round(0.25 * estimation);
        this.high = Math.round(4 * estimation);
        break;
      case 3:
        this.low = Math.round(0.5 * estimation);
        this.high = Math.round(2 * estimation);
        break;
      case 4:
        this.low = Math.round(0.8 * estimation);
        this.high = Math.round(1.25 * estimation);
        break;
      case 5:
        this.low = estimation;
        this.high = estimation;
        break;
    }
  }

  finishQuiz() {
    this.quizMode = false;
    this.stepsArray.shift();
    this.shadowRoot.querySelector('#dev_mode').classList.remove('activated');
    this.updateEstimation();
  }

  addOne(num) {
    num += 1;
    return num;
  }

  toggleQuizMode() {
    const element = this.shadowRoot.querySelector('#dev_mode');
    element.classList.toggle('activated');
    this.quizMode = !this.quizMode;
    this.valuesUpdate();
  }

  invalidEntry(type) {
    if (type == 'confidence') {
      KatapultDialog.alert({
        body: 'Please enter a whole number between 1 and 5 for your confidence',
        dialog: { color: 'var(--paper-red-500)', title: 'Error in confidence input', modal: true }
      });
    }
    if (type == 'string') {
      KatapultDialog.alert({
        body: 'Please enter a positive number',
        dialog: { color: 'var(--paper-red-500)', modal: true, title: 'Error in input' }
      });
    }
  }
}

window.customElements.define('estimator-widget', EstimatorWidget);
